import { getInstance } from "./axiosFactory";
import { raiseError } from "./globalActions";
import { saveState } from "../store/LocalStorage";
import { get } from "lodash";
import Swal from "sweetalert2";
const axiosInstance = getInstance();

export function loginSuccess(loginResult) {
	return { type: "LOGIN_SUCCESSFUL", loginResult };
}

export function loginFailure(failure) {
	return { type: "LOGIN_FAILURE", failure };
}

export function logoutAction() {
	return { type: "LOGOUT" };
}

export const login = (username, Upassword) => {
	console.log("the login", username, Upassword, axiosInstance)
	// return (dispatch) => {
	// console.log("enter log")  

	axiosInstance
		.post("/login", {
			username: username,
			Upassword: Upassword
		})
		.then((res) => {
			saveState({ auth: { ...get(res, "data"), loggedIn: true } });
			console.log("get value", res.data.responce[0].status);
			if (res.data.responce[0].status === "LoggedIn") {
				console.log("success")
				localStorage.setItem("isAuthenticated", "true");
				localStorage.setItem("URole", res.data.responce[0].role);
				localStorage.setItem('ManegerId', res.data.responce[0].Id);
				// saveState({ auth: { ...get(res.data.responce, "role"), logged: true } });
				// setName({ username: "", Upassword: "" });
				window.location.href = "/";

			} else {
				Swal.fire({
					title: "Error",
					text: "Not Authorized User",
					icon: "error",
					confirmButtonText: "Ok",
				});
			}

		})
		.catch(error => {
			console.log("error occur", error);
		})
	// };
};
export const forgetPasswordAction = (emailAddress) => {
	return axiosInstance.post("account/forgetPassword", { emailAddress });
}

export const resetPasswordAction = (newPassword, resetToken) => {
	return axiosInstance.post("account/resetPassword", { newPassword, resetToken });
}

export const resetPasswordURLVisitAction = (resetToken) => {
	return axiosInstance.post("account/resetpasswordurlvisitentry", { resetToken });
}

export const logout = () => {
	return dispatch => {
		localStorage && localStorage.setItem('keepMeLogin', false);
		saveState({});
		dispatch(logoutAction());
	}
}